<script setup>
import Button from '@components/global/button.vue'
import Header from '@components/global/header.vue'
</script>
<template>
  <div class="relative h-[100vh] w-full overflow-hidden">
    <Header />
    <div class="bg-bg-dark">
      <img
        class="absolute bottom-[25%] left-0 w-[20%] min-w-[125px] md:-left-10 md:bottom-0 md:w-[30%]"
        src="https://hennep.s3.amazonaws.com/above/images/not-found/4.svg"
        alt=""
      />

      <img
        class="absolute bottom-0 right-[30%] w-[30%] min-w-[240px] md:bottom-0 md:w-[35%]"
        src="https://hennep.s3.amazonaws.com/above/images/not-found/0-gradient.svg"
        alt=""
      />
      <img
        class="absolute bottom-0 right-[30%] w-[30%] min-w-[240px] md:w-[35%]"
        src="https://hennep.s3.amazonaws.com/above/images/not-found/0.svg"
        alt=""
      />
      <img
        class="absolute -right-0 bottom-[10%] w-[20%] min-w-[225px] md:bottom-[10%] md:w-[30%]"
        src="https://hennep.s3.amazonaws.com/above/images/not-found/4.1.svg"
        alt=""
      />
      <section class="container flex max-w-[400px] flex-col gap-6 text-text-base">
        <div class="break-words font-body text-body-sm font-medium uppercase leading-4 tracking-wide">
          page not found.
        </div>
        <div class="break-words font-heading text-h2 font-medium uppercase leading-10 text-text-base">
          It looks like
          <br />
          you've been
          <br />
          abducted.
        </div>

        <Button class="btn-outline w-fit" :to="{ name: 'home' }"> go back to home </Button>
      </section>
    </div>
  </div>
</template>
